import { ragLabelColorObjs } from 'src/features/brands/ragdelion/constants/colors'

// メーカーラベル
export const labelBase = (ctx: CanvasRenderingContext2D, baseColor: string, outOfEdgeColor: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = outOfEdgeColor
  // メインカラー↓
  ctx.beginPath()
  ctx.fillStyle = baseColor
  ctx.moveTo(374 + x, 561 + y) // 左下
  ctx.quadraticCurveTo(377 + x, 582 + y, 381 + x, 587 + y) // 左下
  ctx.quadraticCurveTo(391 + x, 591 + y, 395 + x, 583 + y) //
  ctx.quadraticCurveTo(398 + x, 553 + y, 398 + x, 551 + y) //
  ctx.quadraticCurveTo(403 + x, 550 + y, 403 + x, 550 + y) //
  ctx.quadraticCurveTo(395 + x, 557 + y, 399 + x, 567 + y) //
  ctx.quadraticCurveTo(400 + x, 574 + y, 412 + x, 578 + y) //
  ctx.quadraticCurveTo(479 + x, 548 + y, 502 + x, 532 + y) //
  ctx.quadraticCurveTo(507 + x, 526 + y, 502 + x, 518 + y) // 右下
  ctx.quadraticCurveTo(497 + x, 514 + y, 488 + x, 515 + y) //
  ctx.quadraticCurveTo(497 + x, 505 + y, 488 + x, 498 + y) //
  ctx.quadraticCurveTo(483 + x, 493 + y, 471 + x, 501 + y) //
  ctx.quadraticCurveTo(473 + x, 489 + y, 458 + x, 486 + y) //
  ctx.quadraticCurveTo(449 + x, 485 + y, 440 + x, 502 + y) //
  ctx.quadraticCurveTo(436 + x, 493 + y, 429 + x, 491 + y) //
  ctx.quadraticCurveTo(422 + x, 492 + y, 415 + x, 495 + y) //
  ctx.quadraticCurveTo(402 + x, 491 + y, 392 + x, 493 + y) //
  ctx.quadraticCurveTo(375 + x, 489 + y, 369 + x, 503 + y) //
  ctx.quadraticCurveTo(362 + x, 509 + y, 364 + x, 517 + y) //
  ctx.quadraticCurveTo(365 + x, 524 + y, 371 + x, 526 + y) //
  ctx.quadraticCurveTo(372 + x, 533 + y, 366 + x, 536 + y) //
  ctx.quadraticCurveTo(355 + x, 546 + y, 351 + x, 554 + y) //
  ctx.quadraticCurveTo(349 + x, 559 + y, 352 + x, 565 + y) //
  ctx.quadraticCurveTo(354 + x, 569 + y, 361 + x, 568 + y) //
  ctx.quadraticCurveTo(374 + x, 562 + y, 374 + x, 561 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const coreLine = (ctx: CanvasRenderingContext2D, coreColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = coreColor
  ctx.fillStyle = coreColor
  ctx.beginPath()
  ctx.moveTo(384 + x, 581 + y) // 左下
  ctx.quadraticCurveTo(390 + x, 564 + y, 386 + x, 544 + y) //
  ctx.quadraticCurveTo(401 + x, 541 + y, 418 + x, 543 + y) //
  ctx.quadraticCurveTo(418 + x, 546 + y, 417 + x, 554 + y) //
  ctx.quadraticCurveTo(405 + x, 559 + y, 405 + x, 559 + y) //
  ctx.quadraticCurveTo(401 + x, 564 + y, 411 + x, 569 + y) //
  ctx.quadraticCurveTo(497 + x, 526 + y, 499 + x, 525 + y) //
  ctx.quadraticCurveTo(494 + x, 524 + y, 494 + x, 524 + y) //
  ctx.quadraticCurveTo(427 + x, 552 + y, 418 + x, 553 + y) //
  ctx.quadraticCurveTo(425 + x, 549 + y, 423 + x, 544 + y) //
  ctx.quadraticCurveTo(447 + x, 541 + y, 447 + x, 541 + y) //
  ctx.quadraticCurveTo(451 + x, 539 + y, 446 + x, 537 + y) //
  ctx.quadraticCurveTo(424 + x, 536 + y, 424 + x, 536 + y) //
  ctx.quadraticCurveTo(425 + x, 526 + y, 426 + x, 526 + y) //
  ctx.quadraticCurveTo(433 + x, 524 + y, 433 + x, 524 + y) //
  ctx.quadraticCurveTo(440 + x, 536 + y, 440 + x, 536 + y) //
  ctx.quadraticCurveTo(442 + x, 536 + y, 442 + x, 536 + y) //
  ctx.quadraticCurveTo(439 + x, 521 + y, 439 + x, 521 + y) //
  ctx.quadraticCurveTo(446 + x, 518 + y, 447 + x, 518 + y) //
  ctx.quadraticCurveTo(446 + x, 535 + y, 457 + x, 534 + y) //
  ctx.quadraticCurveTo(465 + x, 528 + y, 473 + x, 515 + y) //
  ctx.quadraticCurveTo(485 + x, 509 + y, 484 + x, 506 + y) //
  ctx.quadraticCurveTo(469 + x, 510 + y, 458 + x, 515 + y) //
  ctx.quadraticCurveTo(461 + x, 523 + y, 466 + x, 517 + y) //
  ctx.quadraticCurveTo(461 + x, 526 + y, 453 + x, 531 + y) //
  ctx.quadraticCurveTo(450 + x, 525 + y, 455 + x, 510 + y) //
  ctx.quadraticCurveTo(459 + x, 515 + y, 462 + x, 511 + y) //
  ctx.quadraticCurveTo(461 + x, 506 + y, 463 + x, 500 + y) //
  ctx.quadraticCurveTo(456 + x, 492 + y, 454 + x, 500 + y) //
  ctx.quadraticCurveTo(449 + x, 504 + y, 448 + x, 514 + y) //
  ctx.quadraticCurveTo(436 + x, 516 + y, 437 + x, 517 + y) //
  ctx.quadraticCurveTo(429 + x, 501 + y, 429 + x, 501 + y) //
  ctx.quadraticCurveTo(425 + x, 497 + y, 421 + x, 505 + y) //
  ctx.quadraticCurveTo(422 + x, 512 + y, 420 + x, 520 + y) //
  ctx.quadraticCurveTo(416 + x, 523 + y, 416 + x, 523 + y) //
  ctx.quadraticCurveTo(416 + x, 527 + y, 419 + x, 528 + y) //
  ctx.quadraticCurveTo(418 + x, 535 + y, 418 + x, 536 + y) //
  ctx.quadraticCurveTo(394 + x, 531 + y, 390 + x, 535 + y) //
  ctx.quadraticCurveTo(411 + x, 519 + y, 411 + x, 519 + y) //
  ctx.quadraticCurveTo(417 + x, 517 + y, 415 + x, 512 + y) //
  ctx.quadraticCurveTo(414 + x, 501 + y, 407 + x, 502 + y) //
  ctx.quadraticCurveTo(399 + x, 500 + y, 388 + x, 505 + y) //
  ctx.quadraticCurveTo(389 + x, 500 + y, 389 + x, 500 + y) //
  ctx.quadraticCurveTo(379 + x, 502 + y, 379 + x, 502 + y) //
  ctx.quadraticCurveTo(378 + x, 508 + y, 378 + x, 508 + y) //
  ctx.quadraticCurveTo(369 + x, 511 + y, 370 + x, 517 + y) //
  ctx.quadraticCurveTo(374 + x, 520 + y, 378 + x, 517 + y) //
  ctx.quadraticCurveTo(380 + x, 526 + y, 378 + x, 536 + y) //
  ctx.quadraticCurveTo(356 + x, 557 + y, 356 + x, 557 + y) //
  ctx.quadraticCurveTo(356 + x, 561 + y, 356 + x, 562 + y) //
  ctx.quadraticCurveTo(368 + x, 557 + y, 379 + x, 544 + y) //
  ctx.quadraticCurveTo(381 + x, 568 + y, 384 + x, 581 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
// 本体革カラー↓(中央のくり抜き)
export const hollowOutOfLabel = (ctx: CanvasRenderingContext2D, outOfEdgeColor: string, x: number, y: number) => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = outOfEdgeColor
  ctx.fillStyle = outOfEdgeColor
  ctx.beginPath()
  ctx.moveTo(387 + x, 528 + y) // 左下
  ctx.quadraticCurveTo(407 + x, 515 + y, 407 + x, 515 + y) //
  ctx.quadraticCurveTo(406 + x, 513 + y, 406 + x, 509 + y) //
  ctx.quadraticCurveTo(389 + x, 511 + y, 388 + x, 514 + y) //
  ctx.quadraticCurveTo(389 + x, 520 + y, 387 + x, 528 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(426 + x, 518 + y) // 左下
  ctx.quadraticCurveTo(430 + x, 518 + y, 430 + x, 518 + y) //
  ctx.quadraticCurveTo(426 + x, 511 + y, 426 + x, 511 + y) //
  ctx.quadraticCurveTo(426 + x, 519 + y, 425 + x, 519 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const ragdelionLabel = (ctx: CanvasRenderingContext2D, value: string, x: number, y: number, numerator: number, scaleSize: number): void => {
  const colorObject = ragLabelColorObjs.filter((object) => object.value === value)[0]
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  ctx.scale(scaleSize, scaleSize)
  labelBase(ctx, colorObject?.outOfEdge || '#eee', colorObject?.outOfEdge || '#eee', x, y)
  coreLine(ctx, colorObject?.core || '#eee', x, y)
  hollowOutOfLabel(ctx, colorObject?.outOfEdge || '#eee', x, y)
  ctx.restore()
}

export const ragdelionLion = (ctx: CanvasRenderingContext2D, x: number, y: number, strokeAndFillStyle?: string): void => {
  ctx.lineWidth = 0.5
  ctx.strokeStyle = strokeAndFillStyle || '#888888'
  ctx.fillStyle = strokeAndFillStyle || '#888888'
  //  耳_外
  ctx.beginPath()
  ctx.moveTo(480 + x, 367 + y)
  ctx.quadraticCurveTo(468 + x, 363 + y, 463 + x, 371 + y) // 右上
  ctx.quadraticCurveTo(460 + x, 384 + y, 468 + x, 390 + y) // 下1
  ctx.quadraticCurveTo(471 + x, 391 + y, 471 + x, 387 + y) // 下2
  ctx.quadraticCurveTo(467 + x, 382 + y, 469 + x, 375 + y) //
  ctx.quadraticCurveTo(470 + x, 368 + y, 480 + x, 370 + y) //
  ctx.quadraticCurveTo(483 + x, 370 + y, 480 + x, 367 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  耳_内
  ctx.beginPath()
  ctx.moveTo(480 + x, 372 + y)
  ctx.quadraticCurveTo(475 + x, 368 + y, 470 + x, 375 + y) //
  ctx.quadraticCurveTo(470 + x, 383 + y, 477 + x, 386 + y) //
  ctx.quadraticCurveTo(480 + x, 387 + y, 480 + x, 385 + y) // 下
  ctx.quadraticCurveTo(475 + x, 378 + y, 475 + x, 378 + y) //
  ctx.quadraticCurveTo(473 + x, 375 + y, 476 + x, 375 + y) //
  ctx.quadraticCurveTo(480 + x, 375 + y, 480 + x, 375 + y) //
  ctx.quadraticCurveTo(483 + x, 374 + y, 480 + x, 372 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  首ライン
  ctx.beginPath()
  ctx.moveTo(461 + x, 454 + y) // 左下
  ctx.quadraticCurveTo(467 + x, 455 + y, 473 + x, 450 + y) //
  ctx.quadraticCurveTo(473 + x, 455 + y, 473 + x, 455 + y) //
  ctx.quadraticCurveTo(489 + x, 435 + y, 486 + x, 421 + y) //
  ctx.quadraticCurveTo(484 + x, 412 + y, 489 + x, 404 + y) //
  ctx.quadraticCurveTo(490 + x, 401 + y, 489 + x, 401 + y) //
  ctx.quadraticCurveTo(480 + x, 404 + y, 480 + x, 419 + y) //
  ctx.quadraticCurveTo(482 + x, 436 + y, 475 + x, 439 + y) //
  ctx.quadraticCurveTo(473 + x, 447 + y, 461 + x, 454 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  首の右ライン
  ctx.beginPath()
  ctx.moveTo(488 + x, 457 + y) // 左下
  ctx.quadraticCurveTo(498 + x, 453 + y, 499 + x, 442 + y) //
  ctx.quadraticCurveTo(502 + x, 445 + y, 502 + x, 450 + y) //
  ctx.quadraticCurveTo(512 + x, 431 + y, 504 + x, 413 + y) //
  ctx.quadraticCurveTo(493 + x, 398 + y, 495 + x, 386 + y) //
  ctx.quadraticCurveTo(494 + x, 380 + y, 491 + x, 384 + y) //
  ctx.quadraticCurveTo(488 + x, 399 + y, 496 + x, 410 + y) //
  ctx.quadraticCurveTo(503 + x, 428 + y, 498 + x, 430 + y) //
  ctx.quadraticCurveTo(498 + x, 442 + y, 488 + x, 457 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  首の右ライン
  ctx.beginPath()
  ctx.moveTo(496 + x, 400 + y) // 左下
  ctx.quadraticCurveTo(511 + x, 399 + y, 509 + x, 416 + y) //
  ctx.quadraticCurveTo(507 + x, 419 + y, 511 + x, 420 + y) //
  ctx.quadraticCurveTo(516 + x, 417 + y, 520 + x, 425 + y) //
  ctx.quadraticCurveTo(522 + x, 427 + y, 524 + x, 424 + y) //
  ctx.quadraticCurveTo(521 + x, 415 + y, 515 + x, 414 + y) //
  ctx.quadraticCurveTo(515 + x, 403 + y, 509 + x, 400 + y) //
  ctx.quadraticCurveTo(501 + x, 395 + y, 496 + x, 397 + y) //
  ctx.quadraticCurveTo(496 + x, 400 + y, 496 + x, 400 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  顎のライン
  ctx.beginPath()
  ctx.moveTo(524 + x, 424 + y) // 左下
  ctx.quadraticCurveTo(535 + x, 428 + y, 540 + x, 420 + y) //
  ctx.quadraticCurveTo(543 + x, 413 + y, 541 + x, 407 + y) //
  ctx.quadraticCurveTo(539 + x, 406 + y, 539 + x, 406 + y) //
  ctx.quadraticCurveTo(538 + x, 421 + y, 524 + x, 424 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  鼻のライン
  ctx.beginPath()
  ctx.moveTo(543 + x, 407 + y) // 右下
  ctx.quadraticCurveTo(546 + x, 400 + y, 546 + x, 395 + y) //
  ctx.quadraticCurveTo(530 + x, 382 + y, 525 + x, 383 + y) // 上
  ctx.quadraticCurveTo(523 + x, 384 + y, 526 + x, 386 + y) //
  ctx.quadraticCurveTo(538 + x, 396 + y, 538 + x, 396 + y) //
  ctx.quadraticCurveTo(530 + x, 397 + y, 535 + x, 402 + y) //
  ctx.quadraticCurveTo(543 + x, 405 + y, 543 + x, 407 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  目と額のライン
  ctx.beginPath()
  ctx.moveTo(505 + x, 383 + y) // 右下
  ctx.quadraticCurveTo(516 + x, 382 + y, 519 + x, 390 + y) //
  ctx.quadraticCurveTo(523 + x, 390 + y, 523 + x, 390 + y) // 右下
  ctx.quadraticCurveTo(522 + x, 385 + y, 518 + x, 383 + y) //
  ctx.quadraticCurveTo(525 + x, 379 + y, 530 + x, 384 + y) //
  ctx.quadraticCurveTo(519 + x, 365 + y, 508 + x, 362 + y) //
  ctx.quadraticCurveTo(505 + x, 361 + y, 508 + x, 365 + y) //
  ctx.quadraticCurveTo(515 + x, 368 + y, 521 + x, 376 + y) //
  ctx.quadraticCurveTo(502 + x, 377 + y, 505 + x, 383 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //  たてがみライン_右1
  ctx.beginPath()
  ctx.moveTo(508 + x, 359 + y) //  右下
  ctx.quadraticCurveTo(517 + x, 347 + y, 503 + x, 330 + y) //
  ctx.quadraticCurveTo(503 + x, 330 + y, 502 + x, 332 + y) //
  ctx.quadraticCurveTo(504 + x, 341 + y, 501 + x, 351 + y) //
  //  たてがみライン_右2
  ctx.quadraticCurveTo(494 + x, 332 + y, 481 + x, 331 + y) //
  ctx.quadraticCurveTo(476 + x, 331 + y, 483 + x, 337 + y) //
  ctx.quadraticCurveTo(485 + x, 339 + y, 487 + x, 345 + y) //
  //  たてがみライン_右2
  ctx.quadraticCurveTo(465 + x, 331 + y, 411 + x, 371 + y) //
  ctx.quadraticCurveTo(416 + x, 373 + y, 419 + x, 369 + y) //
  ctx.quadraticCurveTo(444 + x, 352 + y, 473 + x, 348 + y) //
  ctx.quadraticCurveTo(487 + x, 346 + y, 491 + x, 362 + y) //
  ctx.quadraticCurveTo(498 + x, 362 + y, 490 + x, 342 + y) //
  ctx.quadraticCurveTo(498 + x, 348 + y, 499 + x, 358 + y) //
  ctx.quadraticCurveTo(501 + x, 361 + y, 503 + x, 356 + y) //
  ctx.quadraticCurveTo(507 + x, 352 + y, 507 + x, 343 + y) //
  ctx.quadraticCurveTo(509 + x, 355 + y, 505 + x, 360 + y) //
  ctx.quadraticCurveTo(508 + x, 359 + y, 508 + x, 359 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const ragdelionString = (ctx: CanvasRenderingContext2D, x: number, y: number, strokeAndFillStyle?: string): void => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = strokeAndFillStyle || '#888888'
  ctx.fillStyle = strokeAndFillStyle || '#888888'
  ctx.beginPath()
  ctx.font = '15px Georgia'
  ctx.strokeText(`RAG de Lion`, 392 + x, 405 + y)
  ctx.closePath()
}

// 捕球面の刻印
export const ragdelionEngravedOfCatchFace = (ctx: CanvasRenderingContext2D, catchFaceColor: string, x: number, y: number): void => {
  const isBright = ['black', 'kBlack', 'uBlack', 'jBlack', 'navy', 'blue', 'red', 'purple', 'chocolate', 'green', 'teal'].includes(catchFaceColor)
  ctx.lineWidth = 0.8
  const strokeAndFillStyle = isBright ? '#bdbbbb' : '#454545'
  ragdelionLion(ctx, x, y, strokeAndFillStyle)
  ragdelionString(ctx, x, y, strokeAndFillStyle)
}

export const ragdelionEngravedOfBackFace = (
  ctx: CanvasRenderingContext2D,
  catchFaceColor: string,
  x: number,
  y: number,
  scaleSize?: number
): void => {
  const isBright = ['black', 'kBlack', 'uBlack', 'jBlack', 'navy', 'blue', 'red', 'purple', 'chocolate', 'green', 'teal'].includes(catchFaceColor)
  ctx.lineWidth = 0.8
  const strokeStyle = isBright ? '#bdbbbb' : '#454545'
  ctx.lineWidth = 1.5
  ctx.strokeStyle = strokeStyle
  ctx.save()
  ctx.scale(scaleSize || 1, scaleSize || 1)
  ctx.beginPath()
  ctx.font = '16px serif'
  ctx.strokeText(`MADE IN SEKIGAHARA`, 330 + x, 530 + y)
  ctx.font = '16px serif'
  ctx.strokeText(`- JAPAN -`, 385 + x, 550 + y)
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}
